import React from 'react';
import { Spin } from 'antd';
import { LoadingContainer } from './styles';

const Loading = () => (
  <LoadingContainer>
    <Spin size='large' />
  </LoadingContainer>
);

export default Loading;
